/**
 * Skalerer og komprimerer et profilbillede i browseren, før det uploades.
 *
 * Billedet beskæres til et kvadrat (midten) og skaleres til maks. 512x512 JPEG.
 * Det holder uploadet på typisk 20-60 KB og betyder at serveren ikke behøver et
 * billedbibliotek - se docs/DECISIONS.md beslutning 015.
 */
const MAX_SIZE = 512
const QUALITY = 0.85

export async function prepareProfilePhoto(input: Blob): Promise<Blob> {
  const bitmap = await createImageBitmap(input)

  try {
    // Beskær til kvadrat om midten, så portrætter ikke bliver trykket sammen.
    const side = Math.min(bitmap.width, bitmap.height)
    const sourceX = (bitmap.width - side) / 2
    const sourceY = (bitmap.height - side) / 2
    const target = Math.min(side, MAX_SIZE)

    const canvas = document.createElement('canvas')
    canvas.width = target
    canvas.height = target

    const context = canvas.getContext('2d')
    if (!context) {
      throw new Error('Browseren kunne ikke behandle billedet.')
    }

    // Hvid baggrund, så gennemsigtige PNG-billeder ikke bliver sorte som JPEG.
    context.fillStyle = '#FFFFFF'
    context.fillRect(0, 0, target, target)
    context.drawImage(bitmap, sourceX, sourceY, side, side, 0, 0, target, target)

    const blob = await new Promise<Blob | null>((resolve) =>
      canvas.toBlob(resolve, 'image/jpeg', QUALITY)
    )

    if (!blob) {
      throw new Error('Billedet kunne ikke konverteres.')
    }

    return blob
  } finally {
    bitmap.close()
  }
}
